import { useTranslation } from 'i18n'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import ConditionalRender from 'utils/conditionalRender'
import FInputError from '../FInputError'
import FInputRadio from './FInputRadio'
import { Box } from 'rebass'
import { input } from '../constants'

interface Props {
    radioDataArray: RadioDataItem[]
    id: string
    name: string
    minimumSelection: number
    errorMessage?: string
}

type RadioDataItem = {
    text: string
    id: string
}

const FInputRadioGroup: React.FC<Props> = (props: Props) => {
    const { errors } = useFormContext()
    const { t } = useTranslation(window.LANG_NS)

    return (
        <React.Fragment>
            <Box id={props.id} style={{ marginTop: input.desktop.marginTop }}>
                {props.radioDataArray.map((radio: RadioDataItem, index: number) => (
                    <FInputRadio value={radio.id} name={`${props.name}`} key={index} text={radio.text} />
                ))}
            </Box>
            <ConditionalRender if={errors[props.name]}>
                <FInputError id={`${props.id}_error`} forElementId={props.id}>
                    {t(errors[props.name]?.message)}
                </FInputError>
            </ConditionalRender>
        </React.Fragment>
    )
}

export default FInputRadioGroup
